'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTreatment = exports.setupFeatureFramework = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _splitio = require('@splitsoftware/splitio');

var _splitio2 = _interopRequireDefault(_splitio);

var _canUseDOM = require('../canUseDOM');

var _canUseDOM2 = _interopRequireDefault(_canUseDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var featureFramework = void 0;

var setupFeatureFramework = exports.setupFeatureFramework = function setupFeatureFramework(authorizationKey) {
  var identity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new _promise2.default(function (resolve, reject) {
    if (featureFramework) return;

    var config = {
      core: { authorizationKey: authorizationKey },
      startup: { readyTimeout: 2 }
    };
    if (_canUseDOM2.default) config.core.key = identity.id;

    var sdk = (0, _splitio2.default)(config);
    featureFramework = sdk.client();
    featureFramework.on(featureFramework.Event.SDK_READY, resolve);
    featureFramework.on(featureFramework.Event.SDK_READY_TIMED_OUT, reject);
  });
};

var getTreatment = exports.getTreatment = function getTreatment(treatment, identity) {
  if (!featureFramework) return 'control';
  if (_canUseDOM2.default) return featureFramework.getTreatment(treatment, identity);
  return featureFramework.getTreatment(identity.id, treatment, identity);
};


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/web-common/dist/features/splitio.js
// module id = 171
// module chunks = 11